import { stores } from '../stores';
import { getStoreValue } from '../stores/store/utils';
import { isB2B } from './environment';
import { Country } from '@staycool/location';
import { Currency } from './wallet/types';

export const CURRENCY_SYMBOL = {
    [Currency.CAD]: '$',
    [Currency.CLP]: '$',
    [Currency.EUR]: '€',
    [Currency.MXN]: '$',
    [Currency.NOK]: 'kr',
    [Currency.PEN]: 'S/.',
    [Currency.SEK]: 'kr',
    [Currency.USD]: '$',
    [Currency.USDT]: '$',
};

const currencyFormatLocales = {
    [Country.CANADA]: 'en-CA',
    [Country.USA]: 'en-US',
    [Country.CHILE]: 'es-CL',
    [Country.ECUADOR]: 'es-EC',
    [Country.MEXICO]: 'es-MX',
    [Country.PERU]: 'es-PE',
    [Country.ESTONIA]: 'fi-FI',
    [Country.FINLAND]: 'fi-FI',
    [Country.SWEDEN]: 'sv-SE',
    [Country.NORWAY]: 'no-NO',
    [Country.ICELAND]: 'nl-BE', // closest format to Iceland
};

const STATIC_RATES = {
    [Currency.CAD]: 1.5,
    [Currency.CLP]: 750,
    [Currency.EUR]: 1,
    [Currency.MXN]: 20,
    [Currency.NOK]: 10,
    [Currency.PEN]: 4,
    [Currency.SEK]: 10,
    [Currency.USD]: 1,
    [Currency.USDT]: 1,
};

const ipCurrency = {
    [Country.CANADA]: Currency.CAD,
    [Country.USA]: Currency.USD,
    [Country.CHILE]: Currency.CLP,
    [Country.ECUADOR]: Currency.USD,
    [Country.MEXICO]: Currency.MXN,
    [Country.PERU]: Currency.PEN,
    [Country.ESTONIA]: Currency.EUR,
    [Country.FINLAND]: Currency.EUR,
    [Country.SWEDEN]: Currency.SEK,
    [Country.NORWAY]: Currency.EUR,
    [Country.ICELAND]: Currency.EUR,
};

export function formattedAmountWithCurrency(
    amount: number,
    options?: { currency?: Currency; maximumFractionDigits?: number },
) {
    let activeCurrency = options?.currency || getActiveCurrency();
    if (activeCurrency === Currency.USDT) {
        activeCurrency = Currency.USD;
    }
    const country = getStoreValue(stores.user)?.country || (getStoreValue(stores.ipCountry) as Country);

    try {
        const formattedAmount = amountWithCurrency(amount, activeCurrency, country, options?.maximumFractionDigits);
        return formattedAmount;
    } catch (error) {
        return amountWithCurrency(amount, Currency.USD, Country.USA);
    }
}

export function amountWithCurrency(amount: number, currency: Currency, country: Country, maximumFractionDigits = 2) {
    const locale = currencyFormatLocales[country];
    const style = {
        style: 'currency',
        currency,
        maximumFractionDigits,
        minimumFractionDigits: maximumFractionDigits,
    };

    return new Intl.NumberFormat(locale, style).format(amount);
}

export function getAmountByStaticRate(amountInEUR: number, currency: Currency, rateMultipliers = STATIC_RATES) {
    return parseFloat((amountInEUR * rateMultipliers[currency]).toFixed(2));
}

export function getActiveCurrency() {
    const wallet = getStoreValue(stores.wallet);
    if (wallet) {
        return wallet.currency;
    }

    if (isB2B()) {
        return Currency.USD;
    }

    const country = getStoreValue(stores.ipCountry);
    return (ipCurrency[country] as Currency) || Currency.EUR;
}
